import type { ServerConnection } from "@/context/server"

export const healthCheckReuseMs = 1000
const verified = new Map<string, number>()

function key(server: ServerConnection.HttpBase) {
  return JSON.stringify([server.url.replace(/\/+$/, ""), server.expectedMachineName ?? "", server.accessToken ?? "", server.username ?? "", server.password ?? ""])
}

export function recordHealthyRoute(server: ServerConnection.HttpBase) {
  const now = Date.now()
  for (const [key, expiresAt] of verified) {
    if (expiresAt <= now) verified.delete(key)
  }
  verified.set(key(server), now + healthCheckReuseMs)
}

export function consumeHealthyRoute(server: ServerConnection.HttpBase) {
  const id = key(server)
  const expiresAt = verified.get(id)
  verified.delete(id)
  return expiresAt !== undefined && expiresAt > Date.now()
}

export function invalidateHealthyRoute(server: ServerConnection.HttpBase) {
  verified.delete(key(server))
}
